import { defineAsyncComponent } from 'vue'
const allComponents = import.meta.glob(['../**/*.vue', '!../**/*.bak.vue'])

export const useLoadComponent = path => {
  const found = Object.keys(allComponents).find(c => c.includes(path))

  if (found) {
    return defineAsyncComponent(async () => {
      try {
        const component = allComponents[found]
        return (await component()).default
      } catch (err) {
        console.log(err)
      }
    })
  } else {
    return null
  }
}
